/* eslint-disable no-undef */
import React, { useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { IconLogo } from 'modules/common/components/Icons';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../actions';

function OtpContainer({ verifyMobile, history, location }) {
  const parseItem = _.get(location, 'search').split('&');
  const token = parseItem[0].split('=')[1];
  const emails = parseItem[1].split('=')[1];

  const [form, setForm] = useState({
    password: '',
    password_confirmation: '',
  });

  const onChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...form,
      reset_token: token,
      email: emails,
    };
    verifyMobile(args, () => {
      history.push('/signin');
    });
  };

  return (
    <div className="login-page login-core login-background--core">
      <div className="container h-100">
        <div className="row h-100 d-flex align-items-center justify-content-center">
          <div className="col-md-5 mx-auto">
            <div className="login-section">
              <div className="header">
                <IconLogo />
              </div>
              <div className="content">
                <div className="login-box">
                  <div className="welcome-intro">
                    <h2 className="title">Verification</h2>
                    <h4 className="description">
                      Please enter the 6-digit code sent to your number
                      and please input your New Password.
                    </h4>
                  </div>
                  <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                      <label className="font-weight-bold">New Password</label>
                      <input
                        className="form-control"
                        type="password"
                        value={form.password}
                        onChange={onChange}
                        name="password"
                      />
                    </div>
                    <div className="form-group">
                      <label className="font-weight-bold">Confirm Password</label>
                      <input
                        className="form-control"
                        value={form.password_confirmation}
                        onChange={onChange}
                        name="password_confirmation"
                        type="password"
                      />
                    </div>
                    <button type="submit" className="btn btn-success btn-block btn-forgot">
                      Submit
                    </button>
                  </form>
                </div>
              </div>
              <div className="footer">
                <Link to="/signin" className="link-signup">
                  <strong>Sign In</strong>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

OtpContainer.propTypes = {
  verifyMobile: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

const mapStateTopRops = () => ({});

export default withRouter(
  connect(
    mapStateTopRops,
    actions,
  )(OtpContainer),
);
